import React from 'react';
import { Checkbox, Field, RadioGroup, TextOutput } from '../../../../../../Core';
import { ListFieldSection } from '../../../../../../Layout';
import { withInjectedProps, NamePrefixModifier } from '../../../../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import { WorksheetAssociatedTestSection } from '../../../../../Core';
import { pipe } from 'Lib/Hooks/Selectors';
import { valueOrDefault } from 'Lib/Any';
import { IWorksheetComponent } from '../../../../../Core/types';

let WashingSection: React.FC<IWorksheetComponent> = ({ namePrefix, createWorksheetSelector }) => {
  const isCoarsePortion = namePrefix?.endsWith('.CoarsePortion') ?? false;
  const isWashed = useSelector(pipe(createWorksheetSelector!('Washing.IsWashed'), valueOrDefault(false)));
  const isWashingOptional = isCoarsePortion;

  return (
    <>
      <NamePrefixModifier appendNamePrefix="Washing">
        <ListFieldSection heading="Washing">
          {isWashingOptional && (
            <Field
              input={<RadioGroup />}
              label="Portion Washed Prior to Sieving"
              name="IsWashed"
              options={[
                { label: 'Yes', value: true },
                { label: 'No', value: false },
              ]}
              confirm={isWashed}
              confirmText="This will clear all washing data for this portion. Are you sure you want to continue?"
            />
          )}
        </ListFieldSection>
        {isWashed && (
          <WorksheetAssociatedTestSection
            testType="Wash"
            associatedTestModel={{
              measured: true,
            }}
            name="AssociatedWashTest"
          />
        )}
      </NamePrefixModifier>
      <ListFieldSection visible={isWashed}>
        <Field input={<TextOutput />} label="Mass of Washings" name="Washing.WashingsDryMass" />
        <Field
          input={<Checkbox />}
          label="Washings added to fine portion"
          name="Sieving.AreWashingsAddedToFinePortion"
          visible={isCoarsePortion}
        />
      </ListFieldSection>
    </>
  );
};

WashingSection = withInjectedProps(WashingSection);

export { WashingSection };
export default WashingSection;
